'use client';

import {Typography} from "@mui/material";
import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import InPressArticle from "@/src/components/journal-site/home/in-press-articles/in-press-article/in-press-article";
import SliderBox from "@/src/components/journal-site/common/vertical-article-slider/mui-custom/slider-box/slider-box";
import {useTheme} from "@mui/material/styles";
import InPressProps from "@/src/_types/in-press-props";

const VerticalArticlesSlider = (props: InPressProps) => {
    const theme = useTheme();

    return (
        <SliderBox>
            <Swiper
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'unset',
                    overflowY: 'clip',
                }}
                direction={'vertical'}
                slidesPerView={2}
                spaceBetween={10}
                loop={true}
                breakpoints={{
                    [theme.breakpoints.values.xs]: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    [theme.breakpoints.values.sm]: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    548: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    [theme.breakpoints.values.md]: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    [theme.breakpoints.values.lg]: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation, Autoplay]}
            >

                {props.articles?.length ? (
                    props.articles.map((article, index) => (
                        <SwiperSlide key={index}
                                     style={{
                                         position: 'relative',
                                         marginBottom: '1.5rem',
                                     }}
                        >
                            <InPressArticle article={article} key={index} number={index+1} />
                        </SwiperSlide>
                    ))
                ) : (
                    <SwiperSlide
                        style={{
                            position: 'relative',
                            marginBottom: '1.5rem',
                        }}
                    >
                        <Typography>
                            {'No articles available.'}
                        </Typography>
                    </SwiperSlide>
                )}
            </Swiper>
        </SliderBox>
    );
};

export default VerticalArticlesSlider;
